// src/hooks/useLogger.js
import { logUserEvent } from '../services/logger';

export function useLogger() {
  const logEvent = (event_type, event_name, page, additionalData = {}) => {
    logUserEvent(event_type, event_name, page, additionalData);
  };
  return logEvent;
}
